import { trackStructEvent } from "@snowplow/browser-tracker";

import { MetricsEvent } from "./snowplow";

const REGISTERED_EVENT_KEYS = new Set<string>();

/**
 * Wrapper on `trackStructEvent` to avoid registering duplicate event metrics
 * for events per app session (e.g. refreshing the page will still register
 * the event).
 */
export const trackStructEventOnceAppSession = (event: MetricsEvent): void => {
  const eventKey: string = event.label
    ? `${event.category}#${event.action}#${event.label}`
    : `${event.category}#${event.action}`;

  if (REGISTERED_EVENT_KEYS.has(eventKey)) return;

  REGISTERED_EVENT_KEYS.add(eventKey);
  trackStructEvent(event);
};
